import PriceInfo from "./PriceInfo/PriceInfo";

const PriceContainer = ({
  channelId,
  messages,
  totalSave,
  totalBlackPrice,
  totalRedPrice,
  discounts,
  formattedPrice,
  productDiscount,
  formatPrice,
  thirtyDayLowestInfo,
  priceInfo,
}) => {
  if (totalSave > 0) {
    const collectedDiscounts = discounts.reduce(
      (acc, discount) => acc + discount.Discount,
      0
    );
    return (
      <div className="lfc-price-container">
        {productDiscount > 0 && <PriceInfo
          thirtyDayLowestInfo={thirtyDayLowestInfo}
          priceInfo={priceInfo}
        />}

        <div className="lfc-ordinary-price">
          {messages.ordinaryPrice}{" "}
          <span>{formatPrice(channelId, totalBlackPrice)}</span>
        </div>
        {discounts.map((discount) => {
          /* These are the campaign-related discounts */
          return (
            <div className="lfc-save" key={discount.PromotionName}>
              {discount.PromotionName} &minus;{discount.FormattedDiscount}
            </div>
          );
        })}
        {productDiscount > 0 ? (
          <div className="lfc-save">
            {/* This is the individual product/package discount */}
            {messages.save} &minus;
            {formatPrice(channelId, collectedDiscounts + productDiscount)}
          </div>
        ) : (
          ""
        )}
        <div className="lfc-campaign-price">{formattedPrice}</div>
      </div>
    );
  } else {
    return (
      <div className="lfc-price-container">
        <div className="lfc-price-no-discount">
          {formattedPrice !== "" && formattedPrice !== null
            ? formattedPrice
            : formatPrice(channelId, totalRedPrice)}
        </div>
      </div>
    );
  }
};

export default PriceContainer;